module.exports = __webpack_public_path__ + "img/abogados.fddd85fa.jpg";